import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';

export interface PushNotificationLogRow {
  id: number;
  user_id: string;
  subscription_endpoint: string | null;
  notification_type: string;
  payload: any;
  status: string;
  error_code: number | null;
  error_message: string | null;
  response_time_ms: number | null;
  created_at: string;
  displayed_at: string | null;
  clicked_at: string | null;
  dismissed_at: string | null;
}

export const PushNotificationLog: Entity<PushNotificationLogRow> = {
  id: 'PushNotificationLog',
  title: 'Push Notification Log',
  service: 'main',
  rowLabel: (row: PushNotificationLogRow) => `${row.notification_type} - ${row.status}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.push_notification_log',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['created_at', 'DESC']],
  defaultFilters: [],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'ID',
      autoIncrement: true,
      persistence: PersistenceType.BackEndManaged,
      visible: false,
    },
    user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      refEntity: UserView,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    notification_type: {
      seq: 15,
      type: FieldType.Options,
      label: 'Type',
      listColumn: true,
      options: [
        { id: 'message', label: 'Message' },
        { id: 'test', label: 'Test' },
        { id: 'system', label: 'System' },
        { id: 'reminder', label: 'Reminder' },
        { id: 'alert', label: 'Alert' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    status: {
      seq: 20,
      type: FieldType.Options,
      label: 'Status',
      listColumn: true,
      options: [
        { id: 'sent', label: 'Sent' },
        { id: 'failed', label: 'Failed' },
        { id: 'expired', label: 'Expired' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    subscription_endpoint: {
      seq: 25,
      type: FieldType.Text,
      label: 'Endpoint',
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
    },
    error_code: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Error Code',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    error_message: {
      seq: 35,
      type: FieldType.Text,
      label: 'Error Message',
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
    },
    response_time_ms: {
      seq: 40,
      type: FieldType.Integer,
      label: 'Response Time (ms)',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    payload: {
      seq: 45,
      type: FieldType.Text,
      label: 'Payload',
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
      visible: false,
    },
    created_at: {
      seq: 50,
      type: FieldType.Datetime,
      label: 'Created At',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    displayed_at: {
      seq: 55,
      type: FieldType.Datetime,
      label: 'Displayed At',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    clicked_at: {
      seq: 60,
      type: FieldType.Datetime,
      label: 'Clicked At',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    dismissed_at: {
      seq: 65,
      type: FieldType.Datetime,
      label: 'Dismissed At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
